<template>
    <div>
        <div class="mb-4 print-group" v-for="category in categories" :key="category.id">
            <h4 class="mb-2"><span class="numbered">{{category.name}}</span></h4>
            <div v-for="element in elements[category.id]" :key="element.id">
                <p>
                    {{element.name}}: <strong v-html="getSelection(category.id, element.id)"></strong>
                </p>
                <p class="support-text text-muted" v-if="hasTextfields(element.id)">
                    <span v-html="getTextfields(element.id)"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    categories() {
      return this.data.categories;
    },
    elements() {
      return this.data.elements;
    },
    selected: {
      get() {
        return this.$store.state.form.form.choises;
      },
      set(val) {
        window.console.log(val);
      }
    },
    elementData() {
      let data = eid => {
        let element = {};
        window._.each(this.elements, e => {
          window._.each(e, elem => {
            if (parseInt(elem.id) === parseInt(eid)) {
              element = elem;
            }
          });
        });
        if (element !== undefined) {
          return JSON.parse(element.data);
        }
      };
      return data;
    }
  },
  methods: {
    getSelection(category, element) {
      let content = "";
      window._.each(this.selected, (s, k) => {
        let parsed = k.split("-");
        let cat = 0;
        let el = 0;
        window._.each(parsed, p => {
          p = p.split("_");
          if (p[0] === "category") {
            cat = p[1];
          } else {
            el = p[1];
          }
        });
        if (
          parseInt(cat) === parseInt(category) &&
          parseInt(el) === parseInt(element)
        ) {
          let choises = {};
          let elem = {};
          switch (this.elementData(parseInt(el)).type) {
            case "ElementItemRadio":
              choises = this.elementData(parseInt(el)).choises.choises;
              elem = window._.find(choises, c => c.id === s);
              if (elem !== undefined) {
                content = elem.content;
              }
              break;

            case "ElementItemCheckbox":
              choises = this.elementData(parseInt(el)).choises.choises;
              elem = [];
              window._.each(s, (v, k) => {
                if (v) {
                  elem.push(window._.find(choises, { id: k }).content);
                }
              });
              content = elem.join(", ");
              break;

            case "ElementItemSelect":
              choises = this.elementData(parseInt(el)).choises.choises;
              elem = window._.find(choises, s);
              content = elem.content;
              break;
            default:
              break;
          }
        }
      });
      return content;
    },
    hasTextfields(e) {
      let val = false;
      window._.each(this.selected, (v, k) => {
        if (k.includes("textfield")) {
          let parsedKey = k.split("_");
          if (parseInt(parsedKey[1]) === parseInt(e)) {
            val = true;
          }
        }
      });
      return val;
    },
    getTextfields(e) {
      let content = [];
      window._.each(this.selected, (v, k) => {
        if (k.includes("textfield")) {
          let parsedKey = k.split("_");
          if (parseInt(parsedKey[1]) === parseInt(e)) {
            content.push(v);
          }
        }
      });
      return content.join(", ");
    }
  }
};
</script>

<style lang="scss">
body {
  counter-reset: section;

  .numbered::before {
    counter-increment: section;
    content: counter(section) ".";
    padding-right: 1rem;
  }
}
</style>
